import {
  LOGIN,
  LOGOUT,
  UPDATE_USER,
  UPDATE_CART,
  SET_IS_AUTH,
  ADD_PRODUCT_DETAILS,
  ADD_STORE,
  ADD_CART,
  UPDATE_MESSAGE_COUNT,
  REMOVE_CART_FROM_STORE,
  UPDATE_USER_AND_CART,
} from "../../constants/actionTypes";
import * as setStore from "./setStore";

const initalState = {
  is_auth: true,
  user: {},
  token: "",
  store: {
    id: 0,
    rows: [],
  },
  cart: [],
  product: {},
};

export default (state = initalState, action) => {
  switch (action.type) {
    case LOGIN:
      return setStore.login(state, action);
    case SET_IS_AUTH:
      return setStore.setIsAuth(state, action.value);
    case LOGOUT:
      return setStore.logout(state, action);
    case UPDATE_USER:
      return setStore.updateUser(state, action.user);
    case UPDATE_CART:
      return setStore.updateCart(state, action.data);
    case ADD_STORE:
      return setStore.addStore(state, action.store);
    case ADD_PRODUCT_DETAILS:
      return setStore.addProductDetails(state, action.data);
    case ADD_CART:
      return setStore.addCart(state, action.store_id);
    case UPDATE_MESSAGE_COUNT:
      return setStore.updateMessageCount(state, action.count);
    case REMOVE_CART_FROM_STORE:
      return setStore.removeCartFromStore(state, action.store_id);
    case UPDATE_USER_AND_CART:
      return setStore.updateUserAndCart(state, action.cart);
    default:
      return state;
  }
};
